import { Component, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICharacterSelectionChanged, ISpecialitiesChanged } from 'src/app/api/interfaces/profile.interface';
import {
  ICompletedCharacterSlots,
  selectCharacterState,
} from 'src/app/store/characterState/characterState.reducer';
import { selectConfigurationsState } from 'src/app/store/configurationState/configurationState.reducer';
import { CraftingService } from '../../../../services/crafting.service';
import { ICraftTypes } from '../../../../services/game-modal.service';

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

@Component({
  selector: 'app-character-selection',
  templateUrl: './character-selection.component.html',
  styleUrls: ['./character-selection.component.scss'],
})
export class CharacterSelectionComponent implements OnInit {
  public characters: ICharacterSelectionChanged[] = [];
  public newcharacters: ICompletedCharacterSlots[] = [];
  public pickedCharacter: ICompletedCharacterSlots | undefined;
  private currentCraftBuildingName: ICraftTypes | undefined;

  constructor(private state: Store, private craftService: CraftingService) {}

  ngOnInit(): void {
    combineLatest([
      this.state.select(selectCharacterState),
      this.state.select(selectConfigurationsState),
      this.craftService.craftingType,
      this.craftService.craftingBuildings,
    ])
      .pipe(
        map((results) => {
          this.pickedCharacter = results[3][results[2].typeName.building]?.slot;
          this.currentCraftBuildingName = results[2];
          return results[0].completedCharacterSlots
            .filter(
              (characterSlot) =>
                characterSlot.status !== 'LOCKED' &&
                characterSlot.status !== 'FREE' &&
                characterSlot.character
            )
            .map((slot) => {
              return {
                ...slot,
                character: slot.character
                  ? {
                      ...slot.character,
                      energy: {
                        ...slot.character.energy,
                        quantityInPercent:
                          this.craftService.getCharacterEnergyInPercent(slot),
                      },
                      specialities: slot.character?.specialities
                        .filter((speciality) =>
                          speciality.config?.recipeBuildings.includes(
                            results[2].typeName.system
                          )
                        )
                        .sort((a, b) => +a.speciality.id - +b.speciality.id),
                    }
                  : null,
              };
            });
        })
      )
      .subscribe((characterState) => {
        const slots: ICompletedCharacterSlots[] = characterState.sort(
          (slotA, slotB) => slotA.sequenceNumber - slotB.sequenceNumber
        );
        this.newcharacters = slots;
      });
  }
  public selectCharacter(character: ICompletedCharacterSlots): void {
    const currentBuilding = this.craftService.craftingBuildings.getValue();
    if (
      this.currentCraftBuildingName &&
      currentBuilding &&
      character.character?.status === 'FREE' &&
      character.character.energy.quantity > 0
    )
      this.craftService.craftingBuildings.next({
        ...currentBuilding,
        [this.currentCraftBuildingName.typeName.building]: {
          ...currentBuilding[this.currentCraftBuildingName.typeName.building],
          slot: character,
        },
      });
  }
  calculateEnergyLevel(quantity: number, capacity: number): number {
    return Math.round((quantity / capacity) * 100);
  }
}
